import React from 'react';
import { ButtonProps } from '../Button/Button';
import { MenuButton as StyledButton } from './Menu';

type MenuButtonProps = Omit<ButtonProps, 'variant'>;

export default function MenuButton({
  children,
  disabled,
  ...rest
}: MenuButtonProps) {
  return (
    <StyledButton variant="outlined" {...rest} disabled={disabled}>
      {children}
      {/* <CaretIcon icon="menu.caretDown" /> */}
    </StyledButton>
  );
}
